"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSmartContent = void 0;
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const context_1 = require("../context");
const utils_1 = require("../utils");
const useSmartContent = (chatInfo) => {
    const { selectedOrgUser } = (0, react_1.useContext)(context_1.OrganizationContext);
    const { t } = (0, react_i18next_1.useTranslation)();
    const tNs = (key, params) => t(key, Object.assign({ ns: "message" }, params));
    const isMemberInGroup = (clinicianData) => {
        const groupInfo = chatInfo;
        const groupMembers = (groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.members)
            ? groupInfo.members.map(member => member.userId)
            : [];
        return groupMembers.includes(clinicianData.id);
    };
    const isReferralMatch = (clinicianData) => {
        const groupInfo = chatInfo;
        const { pendingReferrals } = groupInfo;
        const clinicianId = clinicianData.id;
        return (0, utils_1.hasReferralMatch)(pendingReferrals, clinicianId);
    };
    const getSmartContentMessage = (messageData) => {
        if (!messageData.suggestedClinicians) {
            throw new Error("Content message is not available!");
        }
        if (!messageData.suggestedCliniciansSearchRadius) {
            throw new Error("Suggested clinicians' search radius is not available");
        }
        if (messageData.suggestedClinicians.length > 0) {
            return `${tNs("smartContent.title", {
                clinicians: `${(0, utils_1.getSuggestedDiscipline)(messageData, selectedOrgUser)}`,
            }) +
                (0, utils_1.getMilesFromMeters)(messageData.suggestedCliniciansSearchRadius) +
                tNs("smartContent.miles")}:`;
        }
        return `${tNs("smartContent.emptyTitle") +
            (0, utils_1.getMilesFromMeters)(messageData.suggestedCliniciansSearchRadius) +
            tNs("smartContent.miles")}.`;
    };
    return {
        getSmartContentMessage,
        isMemberInGroup,
        isReferralMatch,
    };
};
exports.useSmartContent = useSmartContent;
